import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import NoAccess from '../pages/NoAccess';

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading, accessDenied } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-slate-50 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-indigo-900 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <Navigate to={accessDenied ? '/login?auth_error=not_authorized' : '/login'} replace />;
  // Signed in is not authorized. An active user holding no permission gets
  // the no-access screen in place of the application -- no shell, no menu, no
  // page that would ask the API for anything -- whatever path they asked for.
  if (!user.authorized) return <NoAccess />;
  if (requiredRole && user.role !== requiredRole) return <Navigate to="/unauthorized" replace />;

  return children;
}
